import { useEffect, useRef } from 'react'
import dashboardApi from 'services/api/dashboard'

import styles from '../AutoInviteInfo.module.scss'

const ShortLinkInput = props => {
  const {
    shortLinkError,
    setShortLinkError,
    setShortLinkValid,
    value,
    chainCode,
    valid,
    isDisabled,
    ...inputProps
  } = props

  const initialValueRef = useRef(value)

  useEffect(() => {
    if (initialValueRef.current && value === initialValueRef.current) {
      setShortLinkValid(true)
    }
  }, [setShortLinkValid, value])

  async function handleChangeShortLink(e) {
    const val = e.target.value

    if (initialValueRef.current && val === initialValueRef.current) {
      setShortLinkValid(true)
      setShortLinkError()
      return
    }

    if (val.length > 4 && val.length < 12) {
      dashboardApi
        .checkShortLinkAvailability(chainCode ? chainCode + '/' + val : val)
        .then(() => {
          setShortLinkValid(true)
          setShortLinkError()
        })
        .catch(err => {
          setShortLinkValid(false)
          setShortLinkError(err.message)
        })
    } else {
      setShortLinkValid(false)
      setShortLinkError('Must be between 4 and 12 characters')
    }
  }

  let containerClass = styles.inputContainer

  if (valid) {
    containerClass = styles.validInputContainer
  }

  if (isDisabled) {
    containerClass = styles.disabledInputContainer
  }

  return (
    <>
      <label>
        <span className={styles.labelText}>Short link identifier</span>
        <div className={containerClass}>
          <span className={styles.disabledInput}>{chainCode}/</span>
          <input
            label="Short link identifier"
            className={styles.input}
            type="search"
            name="urlKey"
            onBlur={handleChangeShortLink}
            value={value}
            disabled={isDisabled}
            {...inputProps}
          />
        </div>
      </label>
      {shortLinkError && <div className={styles.validation}>{shortLinkError}</div>}
    </>
  )
}

export default ShortLinkInput
